import React, { useEffect, useState } from "react";
import classNames from "classnames";
import {
  useDocTypeName,
  useCategoriesApi,
  useArticlesApi,
  useDetailApi,
  useReadAddApi,
} from "./hooks";
import ArticleDetail from "./ArticleDetail";
import APIArticleDetail from "./ApiArticleDetail";
import QuestionDetail from "./QuestionDetail"
import style from "./index.module.scss";
import Utils from 'utils/utils.js';

const Document = ({ docType }) => {
  const [docTypeName] = useDocTypeName(docType, "");
  const [getCategories] = useCategoriesApi(docType);
  const [getArticles] = useArticlesApi(docType);
  const [getArticleDetail] = useDetailApi(docType);
  const [categoryListVisible, setCategoryListVisible] = useState(false);
  const [categories, setCategories] = useState([]);
  const [currentCategory, setCurrentCategory] = useState({});
  const [isClick, setIsClick] = useState(false);
  const [articleDetail, setArticleDetail] = useState({});
  const [tabChange, setTabChange] = useState(false);

  const readContentAdd = useReadAddApi();
 

  useEffect(() => {
 
    if(docType === 'api') getApiCategories()

    if(docType === 'guide') getGuideCategories()

    if(docType === 'faq') getOtherCategories()
    
  }, []); 

  useEffect(() => {
    
    let id = currentCategory && ( currentCategory.articleId || currentCategory.categoryId)
  
      if (id) {
        var newurl = changeURLPar(
          window.location.href,
          "id",
          id
        ); //将uid和现有的页面地址拼接

        window.history.pushState(null, "", newurl); //向当前url添加参数
        
        let param = {
          categoryId:id,
        }

        if(docType != 'faq'){
          param = {
            articleId:id,
          }
        }
        getArticleDetail(param)
          .then(function (response) {
            if (response.status === 200) {
              setTabChange(false);
              const result = response.data;
              if (result.success) {
                const data = result.result;
                setArticleDetail(docType === 'faq'?data.items:data);
              }
            }
          })
          .catch(function (error) {
            console.log(error);
          });
      }
   

  }, [currentCategory]); 

  // 获取 Api 文档分类
  function getApiCategories(){
    getCategories()
       .then(function (response) {
        if (response.status === 200) {
          const result = response.data;
        
          if (result.success) {
            const data = result.result;
            
            let categoryId = getQueryVariable("id")

            for (let i = 0; i < data.length; i++) {
              
              data[i].selected = false;
              data[i].children = [];

              getArticles({
                categoryId: data[i].categoryId,
              }).then((response) => {
                
                if (response.status === 200) {
                  const result = response.data;
                
                  if (result.success) {
                    const res = result.result.items;
                    data[i].children = res;
                    
                    let tag = -1
                    res.forEach((item,x) => {
                      item.levelName2 = data[i].categoryName
                      if(categoryId && item.articleId == categoryId)  tag = x
                      
                    });
                  

                    if(!categoryId && i===0){
                      data[i].selected = true;
                      setCurrentCategory(res[0])
                    } else {
                      if(tag > -1) {
                        data[i].selected = true;
                        setCurrentCategory(res[tag])
                      }
                    }
                  }
                }
              });
            }

            setCategories(data);
          }
        }
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  // 获取常见问题、接入指南 分类
  function getOtherCategories(){
    getCategories({
      pCatogeryId:docType == 'guide'?2:3,
    }).then((response) => {
   
      if (response.status === 200) {
        const result = response.data;
        
        if (result.success) {
          const data = result.result.children;
          let categoryId = getQueryVariable('categoryid'); //获取类目的id
          
          if(!categoryId) {
            categoryId = data[0].children && data[0].children.length > 0 ? data[0].children[0].categoryId : data[0].categoryId
          }
       
          for(let i = 0; i < data.length; i++) {

            let item = data[i];
            if(item.categoryId === categoryId) {
              data[i].selected = true;
              setCurrentCategory(data[i])
            }
            if(item.children && item.children.length) {
              let index = -1
              item.children.forEach((it,x)=>{
                if(it.categoryId == categoryId) index =x
                it.levelName2 = item.categoryName
              })

              if(index > -1) {
                item.selected = true;
                setCurrentCategory(item.children[index])
              
              }
            }
          }
        
          setCategories(data);  
        }
      }
    });
  }

  // 获取接入指南
  function getGuideCategories(){
    getCategories({
      pCatogeryId:docType == 'guide'?2:3,
    }).then((response) => {
   
      const result = response.data;
        
          if (result.success) {
            const data = result.result.children;
           
            let categoryId = getQueryVariable("id")

            for (let i = 0; i < data.length; i++) {
              
              data[i].selected = false;
              

             if(!data[i].children){

              data[i].children = [];

              getArticles({
                categoryId: data[i].categoryId,
              }).then((response) => {
                
                if (response.status === 200) {
                  const result = response.data;
                
                  if (result.success) {
                    const res = result.result.items;
                    data[i].children = res;

                    let tag = -1
                    res.forEach((item,x) => {
                      item.levelName2 = data[i].categoryName
                      if(categoryId && item.articleId == categoryId) {
                        readContentAdd({
                          articleId:item.articleId
                        })
                        tag = x
                      }  
                      
                    });
                  

                    if(!categoryId && i==0){
                      data[i].selected = true;
                      setCurrentCategory(res[0])
                    } else {
                      if(tag > -1) {
                        data[i].selected = true;
                        setCurrentCategory(res[tag])
                      }
                    }
                  }
                }
              });
             } else {
               data[i].children = []
             }
              
              
            }
            console.log('接入指南',data)
            setCategories(data);
          }
    });
  }

  function changeURLPar(uri, par, par_value) {
    var pattern = par + "=([^&]*)";
    var replaceText = par + "=" + par_value;
    if (uri.match(pattern)) {
      //如果连接中带这个参数
      var tmp = "/\\" + par + "=[^&]*/";
      tmp = uri.replace(eval(tmp), replaceText);
      return tmp;
    } else {
      if (uri.match("[?]")) {
        //如果链接中不带这个参数但是有其他参数
        return uri + "&" + replaceText;
      } else {
        //如果链接中没有带任何参数
        return uri + "?" + replaceText;
      }
    }
  }
  function getQueryVariable(variable) {
    var query = window.location.search.substring(1);
    var vars = query.split("&");
    for (var i = 0; i < vars.length; i++) {
      var pair = vars[i].split("=");
      if (pair[0] == variable) {
        return pair[1];
      }
    }
    return "";
  }

  function handleToggleCategoryList() {
    log("vop_open_pc", "vop_open_doc", currentCategory.categoryParentId);
    setCategoryListVisible(!categoryListVisible);
  }

  function handleCategoryChange(category, index) {

    log(
      "vop_open_pc",
      "vop_open_doc",
      currentCategory.categoryParentId,
      category.categoryId
    );

  
    categories[index].selected = !categories[index].selected;
  }

  function handleArticleChange(article) {
    log(
      "vop_open_pc",
      "vop_open_doc",
      currentCategory.categoryParentId,
      article.categoryId,
      article.articleId
    );
    window.scrollTo(0, 0);

    if(docType == 'guide'){
      // 增加埋点记录
      readContentAdd({
        articleId:article.articleId
      })
    }

    if(docType == 'api' && Utils.getQueryVariable('k')){
      setIsClick(true)
    } 
    setCurrentCategory(article)
  }

  function strSub(str){
    if(str.length > 8){
      return str.substring(0,8)+'...'
    }

    return str
  }

  return (
    <div className={`${style.app}`}>
      <div className={`${style.header}`}>
        <div className={`${style.content}`}>
          <div className={`${style.title}`}>
            <img
              className={`${style.icon}`}
              src="https://img10.360buyimg.com/imagetools/jfs/t1/148978/22/11041/349/5f885534E349dd29e/3f847fcbe5316650.png"
              alt=""
            />
            <div className={`${style.text}`}>{docTypeName}</div>
          </div>
          <div className={`${style.breadcrumb}`}>
            <span className={`${style.level1}`}>{docTypeName}</span>
            <span className={`${style.separator}`}>/</span>
            <span className={`${style.level2}`}>
              {currentCategory.levelName2 || currentCategory.categoryName}
            </span>

            {
              currentCategory.levelName2 && (
                <>
                  <span className={`${style.separator}`}>/</span>
                  <span className={`${style.level3}`}>
                    {currentCategory.articleName || currentCategory.categoryName}
                  </span>
                </>
              )
            }
            
          </div>
        </div>
      </div>
      <div className={`${style.main}`}>
        <div className={`${style.sidebar}`}>
          <div
            className={`${style.categoryMenu}`}
            onClick={handleToggleCategoryList}
          >
            {categories.map((category, index) => (
              <div key={index}>
              {
                // category.children && category.children.length > 0 && (
                category && category.children && (
                  <div
                      className={classNames(`${style.categoryItem}`, {
                        [`${style.selected}`]:
                          category.categoryId == currentCategory.categoryId ,
                      })}
                      key={category.categoryId}
                      onClick={() => handleCategoryChange(category, index)}
                    >
                      <span  className={`${style.categoryMenuTitle}`}>{`${category.categoryName.substr(0, 10)}`}</span> 
      
                      <div className={`${style.icon}`}>
                        { category.selected?
                          <img src="https://s2-relay.360buyimg.com/relay/cache/cut/8b8f22934ce58900efa8569c56a26279" /> : 
                          <img src="https://img12.360buyimg.com/imagetools/jfs/t1/136955/36/13151/383/5f904fa6E5a763cdc/ea07ac64495d1923.png" />
                        }
                      </div>
                      
      
                      {docType != 'faq' && category.selected && (
                        <div>
                          {category.children &&
                            category.children.map((article) => {
                              return (
                                <div
                                  key={article.articleId}
                                  className={classNames(`${style.categoryListChild}`, {
                                    [`${style.selected}`]:
                                      currentCategory &&
                                      article.articleId === currentCategory.articleId,
                                  })}
                                  title={article.articleName}
                                  onClick={(e) => {e.stopPropagation(); handleArticleChange(article)}}
                                >
                                  {/* { strSub(article.articleName) } */}
                                  { article.articleName }
                                </div>
                              );
                            })}
                            {" "}
                        </div>
                      )}
      
                      {docType == 'faq' && category.selected && category.children && (
                          <div>
                            {
                              category.children.map((article) => {
                                return (
                                  <div
                                    key={article.categoryId}
                                    className={classNames(`${style.categoryListChild}`, {
                                      [`${style.selected}`]:currentCategory && article.categoryId == currentCategory.categoryId,
                                    })}
                                    title={article.categoryName}
                                    onClick={(e) => {e.stopPropagation(); handleArticleChange(article)}}
                                  >
                                    {/* { strSub(article.categoryName) } */}
                                    { article.categoryName }
                                  </div>
                                );
                              })
                            }
                          </div>
                        )
                        }
                    </div>
                )
              }
              </div>
           
            ))}
          </div>

        </div>
        <div className={`${style.content} __html`}>
          {
            docType === "api" && articleDetail && <APIArticleDetail detail={articleDetail} isClick={isClick}/>
          }{
            docType === "guide" && <ArticleDetail detail={articleDetail} />
          }{
            docType === "faq" && articleDetail.length > 0 && <QuestionDetail detail={articleDetail} />
          }
        </div>
      </div>
    </div>
  );
};

export default Document;
